import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../NewTypes/RootState';

import { initialState } from './slice';

const selectDomain = (state: RootState) => {
  console.log('state.userState', state);

  if (state) {
    return state.userState;
  } else {
    return initialState;
  }
};

export const selectuserListData = createSelector([selectDomain], (state) => state.userList);
export const selectUserData = createSelector([selectDomain], (state) => state.userDetails);
export const SelectPageNo = createSelector([selectDomain], (state) => state.pageNo);
export const SelectPageSize = createSelector([selectDomain], (state) => state.pageSize);
export const SelectTotalRow = createSelector([selectDomain], (state) => state.totalRow);
export const SelectLoading = createSelector([selectDomain], (state) => state.loading);
export const SelectSearch = createSelector([selectDomain], (state) => state.search);
export const SelectCropShow = createSelector([selectDomain], (state) => state.cropShow);
export const SelectSortColumn = createSelector([selectDomain], (state) => state.sortColumn);
export const SelectSortDir = createSelector([selectDomain], (state) => state.sortDir);
